module.exports = __webpack_public_path__ + "img/7.0fb8ab51.jpg";